/* eslint-disable */
import React from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import * as yup from 'yup';
import RHFSelect from 'src/components/elements/Select/RHFSelect';
import RHFEditor from 'src/components/elements/Editor/RHFEditor';
import { Button, Paper } from '@mui/material';
import useYupValidationResolver from 'src/hooks/useYupValidationResolver';
import {
  CurrentInterviewsListValues,
  UpdateInterviewStatus
} from '../../types';
import { useStatuses } from 'src/hooks/query/statuses';
import { DialogContentProps } from 'src/components/Dialog/Dialog';

interface CurrentInterviewsFeedbackProps extends DialogContentProps {
  defaultValues?: any
  onSave?: (data: UpdateInterviewStatus, close: (() => void) | undefined) => void;
}

export interface CurrentInterviewsFeedbackFormValues {
  status: string;
  comments: string;
}

const validationSchema = yup.object().shape({
  status: yup.string().required('Status Required'),
});
const CurrentInterviewsFeedback = function CurrentInterviewsFeedback(props: CurrentInterviewsFeedbackProps) {
  const {
    close,
    defaultValues,
    onSave,
  } = props;
  const resolver = useYupValidationResolver(validationSchema);
  const methods = useForm<CurrentInterviewsFeedbackFormValues>({ resolver });
  const {
    handleSubmit,
  } = methods;
  const submitHandler: SubmitHandler<CurrentInterviewsFeedbackFormValues> = async (data) => {
    const {
      interviewId,
      jobOrderId,
      candidateId,
    } = defaultValues || {};
    const {
      status,
      comments,
    } = data;

    const request = {
      jobOrderId: Number(jobOrderId),
      candidateId: Number(candidateId),
      interviewId: Number(interviewId),
      candidateStatus: status,
      comments,
    };
    if (onSave) {
      onSave(request, close);
    }
  };
  const {
    statusesLoading,
    statusesOptions,
    fetchStatuses,
  } = useStatuses();
  return (
    <Paper>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitHandler)}>
          <div className="pb-2 text-secondary text-center text-lg font-bold">
            <span>
              Panna Live Interview
            </span>
          </div>
          <div className="w-full px-[5%]">
            <RHFSelect
              control={methods.control}
              name="status"
              label="Status"
              options={statusesOptions}
            />
          </div>
          <div className="items-start w-full px-[5%] py-[1%]">
            <div className="items-start w-full text-[#28364C] font-semibold text-base">Comments</div>
            <RHFEditor
              editorType="classic"
              name="comments"
              control={methods.control}
              disabled={false}
              height={250}
            />
          </div>
          <div className="w-full justify-start py-[1%] px-[5%]">
            <Button variant="outlined" type="submit" className="font-medium rounded-full" size="medium">SUBMIT</Button>
          </div>
        </form>
      </FormProvider>
    </Paper>
  );
};

CurrentInterviewsFeedback.defaultProps = {

};

CurrentInterviewsFeedback.propTypes = {

};

export default CurrentInterviewsFeedback;
